import React from "react";
import "./FooterBar.css";
import Socials from "./Socials";
function FooterBar() {
  return (
    <div className="foobar">
      <Socials />
    </div>
  );
}

export default FooterBar;
